// Update swym wishlist button in the main product form
document.addEventListener('variant:changed', function (event) {
  const form = event.target;
  const wishlistBtn = form.querySelector('.wishlist-btn');

  if (wishlistBtn) {
    if (!window.SwymCallbacks) return;

    window.SwymCallbacks[0]();
  };
});

// Footer menu accordions on mobile
const footerAccordionTriggers = document.querySelectorAll('.js-accordion-trigger')
footerAccordionTriggers.forEach(trigger => {
  trigger.addEventListener('click', function () {
    this.closest('.footer__item').classList.toggle('is-open')
  })
})
